import {observer} from "mobx-react";
import styled from "styled-components";
import CareerSlidWrap from "@/app/homepage/main/component/CareerSlidWrap";
import {SIZES} from "@/components/constants";
import {useEffect} from "react";
import {useStore} from "@/store";
import PartneredIcon from "/public/assets/images/main/partnered-ico.png";
import CareerIng from "/public/assets/icons/play-carrer.png"
import CareerStop from "/public/assets/icons/stop-carrer.png"
import moment from "moment";
import {useRouter} from "next/navigation";
import {useMediaQuery} from "react-responsive";

const CareerWrap = observer(() => {
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const {contentStore} = useStore();
    const router = useRouter();
    useEffect(() => {
        let limit = 8
        if(isTablet){
            limit = 4;
        }
        contentStore.setFetchBoardCareerList(limit).then();
        contentStore.setFetchBoardPartnersList().then();
    }, [isTablet]);
    return(
        <>
            {
                (
                    (contentStore.partnersList && contentStore.partnersList.length > 0) ||
                    (contentStore.careerDataList && contentStore.careerDataList.length > 0)
                ) && (
                    <CareerInner>
                        {
                            contentStore.partnersList && contentStore.partnersList.length > 0 &&
                            <div className={"career-slid-area"}>
                                <CareerSlidWrap list={contentStore.partnersList}/>
                                <CareerSlidWrap list={[...contentStore.partnersList].reverse()} type={"reverse"}/>
                            </div>
                        }
                        {
                            contentStore.careerDataList &&
                            contentStore.careerDataList.length > 0 &&
                            <div className={"career-wrapper"}>
                                <div className={"title-wrap"}>
                                    <div className={"title-wrap-inner"}
                                        onClick={() => {
                                            router.push("/homepage/board/list?menu-id=68dcf802655492292e882ce7")
                                        }}
                                    >
                                        <h2>Career</h2>
                                        <div className={"icon-wrap"}><img src={PartneredIcon?.src} alt={"화살표 아이콘"}/></div>
                                    </div>
                                </div>
                                <div className="career-section">
                                    {
                                        contentStore.careerDataList.map((item, idx) => {
                                            const {startDate, endDate} = item.data || {};
                                            const today = moment().startOf("day");
                                            const end = endDate ? moment(endDate, "YYYY-MM-DD") : null;
                                            const isEnded = end && end.isBefore(today, "day");
                                            return (
                                                <div
                                                    className={`career-items ${isEnded ? "end" : ""}`}
                                                    key={item._id || idx}
                                                    onClick={() => {
                                                        if (isEnded) {
                                                            alert("마감된 게시물 입니다.");
                                                        } else {
                                                            router.push(`/homepage/management/detail?menu-id=${item.menuId}&content-id=${item._id}&content-type=list`);
                                                        }
                                                    }}
                                                >
                                                    <div className="classification">{item.data?.classification}</div>
                                                    <div className="title">{item.title}</div>
                                                    <div className="date">
                                                        {
                                                            !isTablet ?
                                                                <>{moment(startDate).format("YYYY.MM.DD")}~{moment(endDate).format("YYYY.MM.DD")}</>
                                                                :
                                                                <>{moment(startDate).format("YYYY.MM.DD")}<br/>~{moment(endDate).format("YYYY.MM.DD")}</>
                                                        }
                                                    </div>
                                                    <div className="state">
                                                        <div className={"state-icon"}><img
                                                            src={isEnded ? CareerIng?.src : CareerStop?.src}
                                                            alt={"상태 아이콘"}/></div>
                                                        {isEnded ? "마감" : "진행중"}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </CareerInner>
                )
            }
        </>
    )
});
const CareerInner = styled.div`
    height: 100%;
    padding: 120px 0 82px;

    .career-slid-area {
        position: relative;

        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none; /* 클릭 막지 않음 */
            background: linear-gradient(
                    to right,
                    #fff 0%,
                    rgba(255, 255, 255, 0) 15%,
                    rgba(255, 255, 255, 0) 85%,
                    #fff 100%
            );
        }
    }

    .career-wrapper {
        max-width: 1280px;
        margin: 30px auto 0;

        
        .title-wrap {
            padding: 0 30px;
            border-bottom: 1px solid #D1D1D1;        
            
            .title-wrap-inner{
                display: flex;
                align-items: center;
                justify-content: start;
                height: 88px;
                cursor: pointer;
                width: 210px;
                h2 {
                    font-weight: 700;
                    font-size: 48px;
                    line-height: 100%;
                    letter-spacing: -0.02em;
                    color: #23203B;
                    transition: all .15s;
                    transform: translateX(16px);
                }

                .icon-wrap {
                    width: 24px;
                    margin-left: 16px;
                    transform: translateX(-20px);
                    opacity: 0;
                    transition: all .15s;
                }
                &:hover{
                    h2 {
                        transform: translateX(0);
                    }
                    .icon-wrap{
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
            }
        }

        .career-section {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(2, auto);
            gap: 30px;
            margin-top: 30px;
            position: relative;
            overflow: hidden;

            &::after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 52%;
                background: linear-gradient(
                        to bottom,
                        rgba(255, 255, 255, 0) 0%,
                        rgba(255, 255, 255, 1) 70%
                );
            }

            .career-items {
                width: 100%;
                height: 220px;
                padding: 30px 20px;
                background: #4939B1;
                border-radius: 20px;
                cursor: pointer;
                overflow: hidden;

                .classification {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 22px;
                    width: 60px;
                    border: 1px solid #F3F2F9;
                    border-radius: 99px;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 22px;
                    color: #F3F2F9;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    -webkit-line-clamp: 1;
                    padding: 0 8px;
                }

                .title {
                    margin-top: 12px;
                    height: 62px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: 600;
                    font-size: 20px;
                    line-height: 30px;
                    color: #fff;
                }

                .date {
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 100%;
                    color: #DFD9FB;
                }
                .state{
                    margin-top: 24px;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 16px;
                    color: #BFB4F7;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    .state-icon{
                        width: 24px;
                    }
                }
                &.end{
                    background: #F3F2F9;
                    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.08), 0px 4px 16px -4px rgba(0, 0, 0, 0.2);
                    border-radius: 20px;
                    .classification{
                        border-color: #ccc;
                        color: #CCCCCC;
                    }
                    .title{
                        color: #ccc;
                    }
                    .date{
                        color: #ccc;
                    }
                    .state{
                        color: #ccc;
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        padding: 130px 0 112px;
        .career-wrapper{
            max-width: 100%;
            margin: 60px 0 0;
            .title-wrap{
                border-bottom: none;
                .title-wrap-inner{
                    height: auto;
                    width: auto;
                    justify-content: center;
                    h2{
                        font-weight: 700;
                        font-size: 32px;
                        line-height: 100%;
                        letter-spacing: -0.02em;
                        color: #0A0323;
                        transform: translateX(0);
                    }
                    .icon-wrap{
                        width: 16px;
                        margin-left: 4px;
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
  

            }
            .career-section{
                display: flex;
                gap: 8px;
                flex-wrap: wrap;
                padding: 20px;
                &::after{
                    display: none;
                }
                .career-items{
                    padding: 20px;
                    width: calc(50% - 8px);
                    height: 160px;
                    .classification{
                        width: 53px;
                        font-size: 12px;
                        line-height: 22px;
                    }
                    .title{
                        margin-top: 8px;
                        font-size: 16px;
                        line-height: 120%;
                        color: #FFFFFF;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        white-space: normal;
                        height: 56px;
                    }
                    .date{
                        margin-top: 10px;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 100%;
                    }
                    .state{
                        display: none;
                    }
                }
            }
        }
    }
`;

export default CareerWrap